import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Accordeon {
  constructor(el) {
    this.el = el
    this.items = [...this.el.querySelectorAll('.accordeon--item')]
    this.filters = [...this.el.querySelectorAll('.accordeon--category')]
    this.activeFilter = null
    this.init()
  }

  init() {
    if (!this.items.length) return

    this.items.forEach((item) => {
      const trigger = item.querySelector('.accordeon--trigger')
      const panel = item.querySelector('.accordeon--panel')
      if (!trigger || !panel) return

      trigger.addEventListener('click', () => this.toggle(item, trigger, panel))
    })

    this.bindFilters()
  }

  bindFilters() {
    this.filters.forEach((btn) => {
      btn.addEventListener('click', () => this.filter(btn.dataset.filter))
    })
  }

  filter(slug) {
    // re-cliquer sur le filtre déjà actif désactive le filtrage (réaffiche tout)
    this.activeFilter = this.activeFilter === slug ? null : slug

    this.filters.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.filter === this.activeFilter)
    })

    this.items.forEach((item) => {
      const cats = item.dataset.cat ? item.dataset.cat.split(' ') : []
      const visible = !this.activeFilter || cats.includes(this.activeFilter)

      if (!visible && item.classList.contains('is-open')) this.close(item)
      item.classList.toggle('is-hidden', !visible)
    })

    ScrollTrigger.refresh()
  }

  toggle(item, trigger, panel) {
    const isOpen = item.classList.contains('is-open')

    if (isOpen) {
      this.close(item)
      return
    }

    // un seul panneau ouvert à la fois
    this.items.forEach((other) => {
      if (other !== item && other.classList.contains('is-open')) this.close(other)
    })

    item.classList.add('is-open')
    trigger.setAttribute('aria-expanded', 'true')

    gsap.to(panel, {
      height: 'auto',
      duration: 0.5,
      ease: 'power2.out',
      onComplete: () => ScrollTrigger.refresh(),
    })
  }

  close(item) {
    const trigger = item.querySelector('.accordeon--trigger')
    const panel = item.querySelector('.accordeon--panel')
    if (!panel) return

    item.classList.remove('is-open')
    if (trigger) trigger.setAttribute('aria-expanded', 'false')

    gsap.to(panel, {
      height: 0,
      duration: 0.4,
      ease: 'power2.in',
      onComplete: () => ScrollTrigger.refresh(),
    })
  }
}
